const sidebarNav = [
    {
        link: '/',
        section: 'home',
        icon: <i className='bx bx-home-alt'></i>,
        text: 'Home'
    },
    {
        link: '/orders',
        section: 'orders',
        icon: <i className='bx bx-receipt' ></i>,
        text: 'Orders'
    },
    {
        link: '/products',
        section: 'products',
        icon: <i className='bx bx-user'></i>,
        text: 'Staff'
    },
    {
        link: '/customers',
        section: 'customers',
        icon: <i className='bx bx-cube'></i>,
        text: 'Daily-Needs'
    },
    {
        link: '/settings',
        section: 'settings',
        icon: <i className='bx bxs-music'></i>,
        text: 'Music'
    },
    {
        link: '/stats',
        section: 'stats',
        icon: <i className='bx bx-line-chart'></i>,
        text: 'Stats'
    }
]

export default sidebarNav